import template from './am-assignments.html';
import { Paging, Assetsfilter } from '../../core/models/am-helper.model';
import { gettext } from '../../../../state/gettext-extract-util';

class AMAssignmentsController {
  constructor(amAssetsService, amOperatorsService, amAssignmentService) {
    'ngInject';

    this.assetService = amAssetsService;
    this.opService = amOperatorsService;
    this.assignmentService = amAssignmentService;
    this.selectedAsset = {};
    this.selectedOperators = {};
    this.command = '';
    this.status = '';

    this.total = null;
    this.filter = new Assetsfilter();
    this.filter.facet = null;
    this.paging = new Paging(15, 1);
    this.steps = [
      {
        name: gettext('Select Assets'),
      },
      {
        name: gettext('Select Operators'),
      },
      {
        name: gettext('Done'),
      },
    ];
    this.stepActiveIndex = 0;

    this.addToDataLayer = (data) => window.dataLayer.push(data);
  }

  get SelectedOperatorsIdsArray() {
    return Object.keys(this.selectedOperators || {});
  }

  get SelectedAssetsIdsArray() {
    return Object.keys(this.selectedAsset || {});
  }

  $onInit() {
    this.setCommand('assign');
  }

  $onChanges() {}

  $onDestroy() {}

  isObjectEmpty(obj) {
    return Object.entries(obj).length === 0;
  }

  nextStep() {
    this.stepActiveIndex++;
  }

  prevStep() {
    this.stepActiveIndex--;
  }

  perform() {
    this.nextStep();
    this.invalidInputs = !this.validInputs();
    if (this.invalidInputs) {
      return;
    }
    const oprIds = this.SelectedOperatorsIdsArray;
    const assetIds = this.SelectedAssetsIdsArray;
    this.status = 'performing';
    this.assignmentService
      .perform(assetIds, oprIds, this.command)
      .then(() => {
        this.stepActiveIndex = null;
        this.status = 'success';

        this.addToDataLayer({
          event: 'updateAssignmentSucceeded',
          data: {
            totalAsset: assetIds.length,
            totalOperator: oprIds.length,
            command: this.command,
          },
        });
      })
      .catch(() => {
        this.status = 'error';

        this.addToDataLayer({
          event: 'updateAssignmentfailed',
          data: {
            totalAsset: assetIds.length,
            totalOperator: oprIds.length,
            command: this.command,
          },
        });
      });
  }

  validInputs() {
    return (
      this.SelectedOperatorsIdsArray.length && this.SelectedAssetsIdsArray.length && this.command
    );
  }

  reset() {
    this.selectedOperators = {};
    this.selectedAsset = {};
    this.resetSteps();
    this.resetStatus();
  }

  setCommand(value) {
    switch (value) {
      case 'assign':
        this.command = this.assignmentService.commands.ASSIGN;
        break;
      case 'unassign':
        this.command = this.assignmentService.commands.UNASSIGN;
        break;
      default:
        this.command = '';
    }
    this.reset();
  }

  resetStatus() {
    this.status = '';
  }

  resetSteps() {
    this.stepActiveIndex = 0;
  }
}

export default {
  template,
  controller: AMAssignmentsController,
  controllerAs: 'assignVm',
  bindings: {},
};
